module.exports = __webpack_public_path__ + "img/PoliceInformation.1c97b5dc.svg";